import omit from 'lodash/omit';
import uniq from 'lodash/uniq';
import { HYDRATE } from 'next-redux-wrapper';

import * as actionCreators from '~/src/features/online-buy/store/actions';
import { initialState, TOnlineBuyData } from '~/src/features/online-buy/store/initialState';
import { InferValueTypes, THydrateAction } from '~/src/store';

export const actionTypes = {
    INITIALIZED: '@online-buy/INITIALIZED',
    INITIATE: '@online-buy/INITIATE',
    SET_DISPLAY_TARIFF_LINE_STATE: '@online-buy/SET_DISPLAY_TARIFF_LINE_STATE',
    SET_TARIFFS: '@online-buy/SET_TARIFFS',
    SET_SELECTED_TARIFF: '@online-buy/SET_SELECTED_TARIFF',
    SET_AGREEMENT_DATA: '@online-buy/SET_AGREEMENT_DATA',
    SET_AGREEMENT_ERROR: '@online-buy/SET_AGREEMENT_ERROR',
    RESET_ONLINE_BUY: '@online-buy/RESET_ONLINE_BUY',
    SET_ONLINE_BUY_ERROR: '@online-buy/SET_ERROR',
    SET_ROUTERS: '@online-buy/SET_ROUTERS',
    SET_ROUTERS_STATUS: '@online-buy/SET_ROUTERS_STATUS',
    ADD_PRODUCT: '@online-buy/ADD_PRODUCT',
    REMOVE_PRODUCT: '@online-buy/REMOVE_PRODUCT',
    SET_SLOT: '@online-buy/SET_SLOT',
    SET_STAGE: '@online-buy/SET_STAGE',
    SET_IS_LOADING: '@online-buy/SET_IS_LOADING',
    SET_IS_HIDE_CALLBACK: '@online-buy/SET_IS_HIDE_CALLBACK',
} as const;

export type TActions = ReturnType<InferValueTypes<typeof actionCreators>>;

export const onlineBuyReducer = (state: TOnlineBuyData = initialState, action: TActions | THydrateAction): TOnlineBuyData => {
    switch (action.type) {
        case HYDRATE:
            return { ...state };
        case actionTypes.SET_TARIFFS: {
            return {
                ...state,
                tariffs: action.payload,
            };
        }
        case actionTypes.SET_ONLINE_BUY_ERROR: {
            return {
                ...state,
                error: action.payload,
            };
        }
        case actionTypes.SET_DISPLAY_TARIFF_LINE_STATE: {
            return {
                ...state,
                displayTariffLine: action.payload.displayState,
            };
        }
        // выбор тарифа
        case actionTypes.SET_SELECTED_TARIFF: {
            return {
                ...state,
                selectedTariff: action.payload,
            };
        }
        case actionTypes.SET_AGREEMENT_DATA: {
            return {
                ...state,
                agreement: action.payload,
            };
        }
        case actionTypes.SET_AGREEMENT_ERROR: {
            return {
                ...state,
                agreement: {
                    ...state.agreement,
                    errorMessage: action.payload,
                    hasError: true,
                },
            };
        }
        case actionTypes.SET_STAGE: {
            return {
                ...state,
                stage: action.payload,
            };
        }
        case actionTypes.SET_SLOT: {
            return {
                ...state,
                slot: action.payload,
            };
        }
        case actionTypes.SET_IS_LOADING: {
            return {
                ...state,
                isLoading: action.payload,
            };
        }
        case actionTypes.SET_IS_HIDE_CALLBACK: {
            return {
                ...state,
                isHideCallBack: action.payload,
            };
        }
        case actionTypes.RESET_ONLINE_BUY: {
            return initialState;
        }
        case actionTypes.SET_ROUTERS_STATUS: {
            return {
                ...state,
                routers: { ...state.routers, status: action.payload },
            };
        }
        case actionTypes.SET_ROUTERS: {
            return {
                ...state,
                routers: action.payload,
            };
        }
        case actionTypes.ADD_PRODUCT: {
            // todo-porotikova вынести в actions
            const { id, isInstallment, quantity } = action.payload;
            const stateSelectedProducts = state.selectedProducts;
            const sameProduct = stateSelectedProducts.products[id];
            const instalmentQuantity = sameProduct?.isInstallment || isInstallment
                ? +isInstallment
                : stateSelectedProducts.instalmentQuantity;

            return {
                ...state,
                selectedProducts: {
                    products: { ...stateSelectedProducts.products, [id]: action.payload },
                    order: uniq([...stateSelectedProducts.order, id]),
                    commonQuantity: stateSelectedProducts.commonQuantity - (sameProduct?.quantity || 0) + quantity,
                    instalmentQuantity,
                },
            };

        }
        case actionTypes.REMOVE_PRODUCT: {
            // todo-porotikova вынести в actions
            const stateSelectedProducts = state.selectedProducts;
            const idRemovedProduct = action.payload.productId;
            const countForDelete = action.payload.count;

            const removedProduct = stateSelectedProducts.products[idRemovedProduct];
            const isLast = removedProduct?.quantity === 1 || !countForDelete;

            return {
                ...state,
                selectedProducts: {
                    products: isLast
                        ? omit(stateSelectedProducts.products, idRemovedProduct)
                        : {
                            ...stateSelectedProducts.products,
                            [idRemovedProduct]: { ...removedProduct, quantity: removedProduct.quantity - 1 },
                        },
                    order: isLast
                        ? stateSelectedProducts.order.filter(id => id !== idRemovedProduct)
                        : stateSelectedProducts.order,
                    commonQuantity: countForDelete
                        ? stateSelectedProducts.commonQuantity - countForDelete
                        : stateSelectedProducts.commonQuantity - removedProduct.quantity,
                    instalmentQuantity: removedProduct.isInstallment ? 0 : stateSelectedProducts.instalmentQuantity,
                },
            };

        }
        default: {
            const unknownAction = action;
            return state || unknownAction;
        }
    }
};
